module.exports = __webpack_public_path__ + "static/mrgreen-67cacc9cebdfc930736973e722c65457.jpg";